import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { map, Subject } from 'rxjs';
import { CopyButtonComponent } from 'src/app/shared/components/copy-button/copy-button.component';

@Component({
  selector: 'app-text-with-copy-renderer',
  imports: [CopyButtonComponent],
  templateUrl: './text-with-copy-renderer.html',
  styleUrl: './text-with-copy-renderer.scss',
  host: {
    class: 'renderer',
  },
})
export class TextWithCopyRendererComponent<TData>
  implements ICellRendererAngularComp
{
  private paramsSubj = new Subject<ICellRendererParams<TData>>();
  value = toSignal(this.paramsSubj.pipe(map(params => params.value)), {
    initialValue: '',
  });
  agInit(params: ICellRendererParams<TData>): void {
    this.paramsSubj.next(params);
  }
  refresh(params: ICellRendererParams<TData>): boolean {
    this.paramsSubj.next(params);
    return true;
  }
}
